import { render, staticRenderFns } from "./FtaInfoTap.vue?vue&type=template&id=0ba225fe&scoped=true"
import script from "./FtaInfoTap.vue?vue&type=script&lang=js"
export * from "./FtaInfoTap.vue?vue&type=script&lang=js"
import style0 from "./FtaInfoTap.vue?vue&type=style&index=0&id=0ba225fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba225fe",
  null
  
)

export default component.exports